import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ProtectHero } from "./components/ProtectHero";
import { ProtectTab } from "./components/ProtectTab";
import styled from "styled-components";
const ProtectCenterPageWrapper = styled.div.withConfig({
    componentId: "sc-9255d34-0"
})(_templateObject());
export const ProtectCenterPage = ()=>{
    return /*#__PURE__*/ _jsxs(ProtectCenterPageWrapper, {
        children: [
            /*#__PURE__*/ _jsx(ProtectHero, {}),
            /*#__PURE__*/ _jsx(ProtectTab, {})
        ]
    });
};
